import React, { Component } from 'react'
import BuyTicketMovieTitles from './BuyTicketMovieTitles.jsx';
import BuyTicketLink from './BuyTicketLink.jsx';
import BuyTicketMovieDates from './BuyTicketMovieDates.jsx';
import BuyTicketMovieShowtimes from './BuyTicketMovieShowtimes.jsx';
import PerformancePage from '../../PerformancePage/index.jsx';
import Translation from '../../General/Translation.jsx';
import getMomentNow from '../../functions/getMomentNow.js';
import BuyTicketCinemaList from './BuyTicketCinemaList.jsx';

const selectSettings = {
    isClearable:true,
    className:'select-container',
    isSearchable:false,
    classNamePrefix:"select"
}

class MenuItemBuyTicket extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { state, onClick, translation, buyTicketAnimation, isMobile, clusterCinemaActive, cinemaPkList, filledWithColorClass, cinemas, itemBuyTicketIsOpen, movies, moviesOrder, changeMovieShowtime, changeCinema, changeMovieDate, changeMovieTitle, openIframe } = this.props
        
        if(!movies || Object.keys(translation.strings).length === 0) {
            return ''
        }
        
        const activeClass = itemBuyTicketIsOpen ? ' sub-menu-item-active' : ''
        const activeSubmenuClass = itemBuyTicketIsOpen ? ' is-active' : ''
        const hasAnimationClass = buyTicketAnimation ? ' animation' : '' 
        const clusterCinemaActiveClass = clusterCinemaActive ? ' is-multi-cinema' : ''
        const dateNow = getMomentNow(translation.timezone)
        const closeIFrame = () => {openIframe(false, null, null)}

        return (
            <div className={"menu-item-buy-ticket-container" + hasAnimationClass + activeClass + clusterCinemaActiveClass + filledWithColorClass}>
                <div className={"menu-item menu-item-buy-ticket" + activeClass}>
                    <a className="menu-buy-ticket-button text-medium-navigation menu-item-buy-ticket-link menu-item-link cursor-pointer" onClick={() => onClick()}>
                        {filledWithColorClass === ' partly-colored-header' ? !isMobile ? '' : (
                            <div className='quick-ticket-icon'>
                                {!activeClass && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.54 62.29">
                                        <g id="a"/>
                                        <g id="b">
                                            <g id="c">
                                                <g>
                                                    <rect className="d" x="110.36" y="8.72" width="9.07" height="4.57" transform="translate(103.83 125.9) rotate(-89.97)"/>
                                                    <polygon className="d" points="117.25 33.21 117.28 42.27 112.69 42.28 112.66 33.22 117.25 33.21"/>
                                                    <polygon className="d" points="117.25 19.84 117.28 28.9 112.69 28.91 112.66 19.85 117.25 19.84"/>
                                                    <polygon className="d" points="117.38 46.58 117.41 55.64 112.82 55.65 112.79 46.59 117.38 46.58"/>
                                                    <rect className="d" x="14.98" y="14.4" width="48.94" height="4.7"/>
                                                    <rect className="d" x="24.79" y="28.8" width="48.2" height="4.7"/>
                                                    <rect className="d" y="43.19" width="56.76" height="4.7"/>
                                                    <path className="d" d="M145.42,38.63c-3.66-.95-5.35-4.09-5.47-7.51-.12-3.42,1.44-6.59,4.73-7.49,5.25-1.43,6-4.9,5.71-9.44-.18-2.81-.09-5.65-.08-8.47,.05-3.86-1.72-5.82-5.75-5.71C140.75,.11,46.26,0,46.26,0V4.7l99.56-.12c.03,4.63,.07,9.09,.09,13.6-6.47,2.04-10.5,6.07-10.44,13.02,.09,6.72,4.35,10.4,10.5,12.59v13.53l-99.73,.28v4.7c2.12,0,76.07-.37,97.69-.46,5.35-.02,6.52-1.18,6.55-6.38,.03-3.17-.13-6.33,.03-9.49,.21-3.88-1.1-6.3-5.1-7.34Z"/>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>}
                                {activeClass && <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <polygon className="cls-1" points="30 2.13 27.87 0 15 12.87 2.13 0 0 2.13 12.87 15 0 27.87 2.13 30 15 17.13 27.87 30 30 27.87 17.13 15 30 2.13"/>
                                </svg>}
                                </div>
                            ) : (
                                <div className='quick-ticket-icon'>
                                    {!activeClass && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.54 62.29">
                                        <g id="a"/>
                                        <g id="b">
                                            <g id="c">
                                                <g>
                                                    <rect className="d" x="110.36" y="8.72" width="9.07" height="4.57" transform="translate(103.83 125.9) rotate(-89.97)"/>
                                                    <polygon className="d" points="117.25 33.21 117.28 42.27 112.69 42.28 112.66 33.22 117.25 33.21"/>
                                                    <polygon className="d" points="117.25 19.84 117.28 28.9 112.69 28.91 112.66 19.85 117.25 19.84"/>
                                                    <polygon className="d" points="117.38 46.58 117.41 55.64 112.82 55.65 112.79 46.59 117.38 46.58"/>
                                                    <rect className="d" x="14.98" y="14.4" width="48.94" height="4.7"/>
                                                    <rect className="d" x="24.79" y="28.8" width="48.2" height="4.7"/>
                                                    <rect className="d" y="43.19" width="56.76" height="4.7"/>
                                                    <path className="d" d="M145.42,38.63c-3.66-.95-5.35-4.09-5.47-7.51-.12-3.42,1.44-6.59,4.73-7.49,5.25-1.43,6-4.9,5.71-9.44-.18-2.81-.09-5.65-.08-8.47,.05-3.86-1.72-5.82-5.75-5.71C140.75,.11,46.26,0,46.26,0V4.7l99.56-.12c.03,4.63,.07,9.09,.09,13.6-6.47,2.04-10.5,6.07-10.44,13.02,.09,6.72,4.35,10.4,10.5,12.59v13.53l-99.73,.28v4.7c2.12,0,76.07-.37,97.69-.46,5.35-.02,6.52-1.18,6.55-6.38,.03-3.17-.13-6.33,.03-9.49,.21-3.88-1.1-6.3-5.1-7.34Z"/>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>}
                                {activeClass && <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <polygon className="cls-1" points="30 2.13 27.87 0 15 12.87 2.13 0 0 2.13 12.87 15 0 27.87 2.13 30 15 17.13 27.87 30 30 27.87 17.13 15 30 2.13"/>
                                </svg>}
                                </div>
                            )}
                        <span className='quick-ticket-text'><Translation id="getTicketsImmediately" trans={translation}>Quick Ticket</Translation></span>
                    </a>

                    <ul className={"buy-ticket-sub-menu" + activeSubmenuClass}>
                       {clusterCinemaActive && <li className="buy-ticket-sub-menu-item cinemas">
                            <BuyTicketCinemaList
                                movies={movies} 
                                translation={translation}
                                dateNow={dateNow}
                                moviesOrder={moviesOrder}
                                state={state}
                                selectSettings={selectSettings}
                                changeCinema={changeCinema}
                                cinemaPkList={cinemaPkList}
                                cinemas={cinemas}
                                />
                        </li>}
                        <li className="buy-ticket-sub-menu-item movie-titles">
                            <BuyTicketMovieTitles 
                                movies={movies} 
                                translation={translation}
                                dateNow={dateNow}
                                moviesOrder={moviesOrder}
                                state={state}
                                selectSettings={selectSettings}
                                changeMovieTitle={changeMovieTitle}
                                />
                        </li>
                        <li className="buy-ticket-sub-menu-item movie-dates">
                            <BuyTicketMovieDates 
                                movies={movies}
                                translation={translation}
                                dateNow={dateNow}
                                moviesOrder={moviesOrder}
                                changeMovieDate = {changeMovieDate}
                                state={state}
                                selectSettings={selectSettings}
                                />
                        </li>
                        <li className="buy-ticket-sub-menu-item movie-showtimes">
                            <BuyTicketMovieShowtimes 
                                movies={movies}
                                translation={translation}
                                dateNow={dateNow}
                                moviesOrder={moviesOrder}
                                changeMovieShowtime={changeMovieShowtime}
                                state={state}
                                selectSettings={selectSettings}
                            />
                        </li>
                        <li className="buy-ticket-sub-menu-item movie-buy-tickets-button">
                            <BuyTicketLink 
                                state={state} 
                                movies={movies} 
                                translation={translation}
                                openIframe={openIframe}
                                cinemas={cinemas}
                                clusterCinemaActive={clusterCinemaActive}
                            />
                        </li>
                    </ul>

                    {state.iframeIsOpen && itemBuyTicketIsOpen &&
                        <>
                            <div className={"popup has-popup-close backdrop-transparent"} onClick={closeIFrame}></div>
                            <ul className={"buy-ticket-sub-menu performance-page" + activeSubmenuClass}>
                                <div className="close-button cursor-pointer" onClick={closeIFrame}>
                                    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                        <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                                    </svg>
                                    <span className="screen-reader-text">Close</span>
                                </div>
                                <div className="performance-page-wrapper">
                                    <PerformancePage 
                                        showId={state.iframeIsOpen.showId} 
                                        deeplinkURL={state.iframeIsOpen.deeplinkUrl}
                                        cinema={state.iframeIsOpen.cinema}
                                    />
                                </div>
                            </ul>
                        </>
                    }

                </div>
            </div>
        )  
    }
}

export default MenuItemBuyTicket